import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'
import Modal from '../Modal'
import { createModalPortal } from 'utils/createModalPortal'
import { Title, Content, CustomButton, Container } from './styles'

interface FinalLessonModalProps {
  onClose(): void
  open: boolean
  moduleName: string
  lessonName: string
  isFinalModule?: boolean
  handleContentNavigate(type: string): void
}

const FinalLessonModal: React.FC<FinalLessonModalProps> = ({
  onClose,
  open,
  moduleName,
  lessonName,
  isFinalModule,
  handleContentNavigate,
}) => {
  const {
    profile: { name },
  } = useSelector((state: RootState) => state.student)

  return createModalPortal(
    <Modal onClose={onClose} open={open}>
      <Container>
        <Title>
          Parabéns, {name.split(' ')[0]}!
          {isFinalModule
            ? ' Você chegou ao fim deste módulo!'
            : ' Você chegou ao final desta aula!'}
        </Title>
        {isFinalModule ? (
          <Content>
            Você finalizou o módulo <b>{moduleName}</b> e está mais perto da sua aprovação. Agora
            vamos respirar um pouco?
          </Content>
        ) : (
          <Content>
            Você finalizou a aula <b>{lessonName}</b> e está mais perto da sua aprovação. Agora
            vamos respirar um pouco?
          </Content>
        )}
        <Content>
          Descanse por alguns minutos e volte para o nosso próximo conteúdo. Te espero lá!
        </Content>
        <CustomButton onClick={() => handleContentNavigate('next_lesson')}>
          {isFinalModule ? 'Concluir e voltar à listagem' : 'Ir para próxima aula'}
        </CustomButton>
      </Container>
    </Modal>
  )
}

export default FinalLessonModal
